export default ({ baseType }) => ({
  START: `FETCH_${baseType}_START`,
  SUCCESS: `FETCH_${baseType}_SUCCESS`,
  ERROR: `FETCH_${baseType}_ERROR`,
  SAVE_TO_BACKEND_SUCCESS: `SAVE_TO_BACKEND_${baseType}_SUCCESS`,
  CREATE_IN_BACKEND_SUCCESS: `CREATE_IN_BACKEND_${baseType}_SUCCESS`,
  DELETE_FROM_BACKEND_SUCCESS: `DELETE_FROM_BACKEND_${baseType}_SUCCESS`,
  OBJECT_CREATED: `NEW_${baseType}_CREATED`,
  OBJECTS_CREATED: `NEW_${baseType}S_CREATED`,
  FIELDS_UPDATED: `${baseType}_FIELDS_UPDATED`,
  VALIDATION_ERRORS_RECEIVED: `${baseType}_VALIDATION_ERRORS_RECEIVED`,
  PURGE: `${baseType}_PURGE`
});
